"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ButtonWithDropdown = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
require("./styles.css");
var ButtonWithDropdown = function (_a) {
    var expanded = _a.expanded, doExpand = _a.doExpand, buttonContent = _a.buttonContent, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.renderButton, renderButton = _c === void 0 ? function (props) { return react_1["default"].createElement(Button_1.Button, __assign({}, props, { type: "solid-primary" })); } : _c, restProps = __rest(_a, ["expanded", "doExpand", "buttonContent", "children", "className", "renderButton"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "vs-dropdown-with-button ".concat(className) }),
        renderButton({
            expanded: expanded,
            className: "vs-dropdown-with-button-button ".concat(className, "-button"),
            onClick: doExpand,
            children: buttonContent
        }),
        react_1["default"].createElement("div", { className: ['vs-dropdown', expanded ? 'vs-visible' : ''].join(' ') }, children)));
};
exports.ButtonWithDropdown = ButtonWithDropdown;
